module.exports = __webpack_public_path__ + "img/Group262.ce6417bf.png";